export const legalAgreementsContactEn = {
  legalAgreements_contactTitle: "Questions about these agreements?",
  legalAgreements_contactText:
    "If you have questions about Jandi or these agreements, write to us:",
  legalAgreements_contactAddress:
    "Jandi PR LLC · PO Box 1291 · San Lorenzo, PR 00754",
};
